<template>
    <div class="overflow-hidden border border-gray-300 rounded-md">
        <div class="flex items-center bg-gray-100">
            <div class="w-3/12 py-2 px-2 font-bold">Название акции</div>
            <div class="w-3/12 py-2 font-bold">Название кнопки</div>
            <div class="w-3/12 py-2 font-bold">Ссылка акции</div>
            <div class="w-3/12 py-2 font-bold">Активен</div>
        </div>

        <div
            v-for="item in list"
            :key="item.id"
            class="flex items-center h-10 py-4 border-t border-gray-300"
        >
            <div class="w-3/12 truncate px-2">
                <span
                    class="text-purple-700 cursor-pointer hover:underline"
                    @click="$emit('select', item.id)"
                >
                    {{ item.name }}
                </span>
            </div>

            <div class="w-3/12 py-2">{{ item.button_name }}</div>
            <div class="w-3/12 py-2">{{ item.url }}</div>

            <div class="w-3/12">
                <CBadge :color="item.enabled ? 'success' : 'secondary'">
                    {{ item.enabled ? "Да" : "Нет" }}
                </CBadge>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        components: {},

        props: {
            list: {
                type: Array,
                default: () => [],
            },
        },
    };
</script>
